module.exports = __webpack_public_path__ + "img/teach_2.2.4085bf16.png";